import { createIntl, createIntlCache } from '@formatjs/intl';
import { useIntlProviderData } from '@mb/lib';

const cache = createIntlCache();

export let intl = createIntl(
  {
    // Locale of the application
    locale: 'en',
    // Locale of the fallback defaultMessage
    defaultLocale: 'en',
    messages: {},
  },
  cache,
);

useIntlProviderData().then(({ localeData }) => {
  intl = createIntl(
    {
      // Locale of the application
      locale: localeData.currentLocale,
      // Locale of the fallback defaultMessage
      defaultLocale: 'en',
      messages: localeData.messages,
    },
    cache,
  );
  window.__INTL_FORMATER__ = intl;
});
